import { useEffect, useContext } from 'react'
import { AppContext } from '../../index'
import ReactGA from 'react-ga'

let gaInitialized = false

function GoogleAnalytics() {
  const { state } = useContext(AppContext)
  const { user } = state.auth
  const email = user ? user.email : null

  useEffect(() => {
    const trackingId = process.env.REACT_APP_GA_TRACKING_ID
    if (trackingId) {
      ReactGA.initialize(trackingId)

      gaInitialized = true
    }
  }, // eslint-disable-next-line
    [])

  useEffect(() => {
    if (gaInitialized && email) {
      ReactGA.set({
        userId: email
      })
    }
  }, [email])

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
  })

  return null
}

export default GoogleAnalytics
